
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea0d1"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea0d1"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("18GLK", function(module, exports) {

$parcel$export(module.exports, "register", () => $0d47b6de68ea1896$export$6503ec6e8aabbaf, (v) => $0d47b6de68ea1896$export$6503ec6e8aabbaf = v);
var $0d47b6de68ea1896$export$6503ec6e8aabbaf;
var $0d47b6de68ea1896$export$f7ad0328861e2f03;
"use strict";
var $0d47b6de68ea1896$var$mapping = new Map();
function $0d47b6de68ea1896$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0d47b6de68ea1896$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0d47b6de68ea1896$var$resolve(id) {
    var resolved = $0d47b6de68ea1896$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0d47b6de68ea1896$export$6503ec6e8aabbaf = $0d47b6de68ea1896$var$register;
$0d47b6de68ea1896$export$f7ad0328861e2f03 = $0d47b6de68ea1896$var$resolve;

});

var $0a76a31222b3161b$exports = {};

(parcelRequire("18GLK")).register(new URL("", import.meta.url).toString(), JSON.parse('["jARM5","index.8c4df020.js","lLZAy","hercules.851e22fa.png"]'));


//# sourceMappingURL=index.runtime.824f144a.js.map
